import axios from "axios";

const urlPath = "productoKae";

export const getProductosKae = async () => {
  try {
    const response = await axios.get(urlPath);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};
export const getProductosKaeAlmacen = async (id) => {
  try {
    const response = await axios.get(`${urlPath}/almacen/${id}`);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getProductoKae = async (id) => {
  try {
    const response = await axios.get(`${urlPath}/${id}`);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const createProductoKae = async (data) => {
  try {
    const response = await axios.post(urlPath, {
      nombre: data.nombre,
      sku: data.sku,
      descripcion: data.descripcion,
      categoria_id: data.categoria_id,
      precio_compra: data.precio_compra,
      precio_venta: data.precio_venta,
      obligatorio: !!data.obligatorio,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const updateProductoKae = async (id, data) => {
  try {
    const response = await axios.put(`${urlPath}/${id}`, {
      nombre: data.nombre,
      sku: data.sku,
      descripcion: data.descripcion,
      categoria_id: data.categoria_id,
      precio_compra: data.precio_compra,
      precio_venta: data.precio_venta,
      obligatorio: !!data.obligatorio,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const deleteProductoKae = async (id) => {
  try {
    const response = await axios.delete(`${urlPath}/${id}`);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};
